// extracted by mini-css-extract-plugin
module.exports = {"container":"ChipList_container__bkb7e"};